module.exports = {
  domain: 'A',
  title: 'Medmenneskelighet',
  shortDescription: 'Medmenneskelighet henspeiler på individuelle forskjeller når det gjelder samarbeid og sosial harmoni. Medmenneskelige individer setter det å komme overens med andre høyt.',
  description: `De er derfor hensynsfulle, vennlige og villige til å finne kompromisser dersom det er interessekonflikter.
Medmenneskelige individer har også et optimistisk syn på menneskenaturen. De tror at mennesker i bunn og grunn er ærlige, redelige og til å stole på.
Lite medmenneskelige individer setter egne interesser over det å komme overens med andre. De er generelt ikke så opptatt av andres ve og vel, og vil derfor ikke strekke seg langt for andre mennesker.
<br /><br />
Noen ganger er det deres skepsis når det gjelder andres motiver som forårsaker deres mistenksomhet, uvennlighet og mangel på samarbeidsvilje.
Medmenneskelighet er svært fordelaktig for å bli populær og for å fortsette å være det.
<br /><br />
Medmenneskelige individer er bedre likt enn de som er lite medmenneskelig.
Men medmenneskelighet er ingen nyttig egenskap i situasjoner der det kreves at man tar tøffe og helt objektive beslutninger.
Lite medmenneskelige individer kan bli dyktige vitenskapsmenn, kritikere eller soldater.`,
  results: [
    {
      score: 'low',
      text: 'Ditt resultat på medmenneskelighet er lavt, noe som tyder på at du er mindre opptatt av andres behov enn dine egne. Folk ser deg som tøff, kritisk og kompromissløs.'
    },
    {
      score: 'neutral',
      text: 'Ditt resultat på medmenneskelighet er gjennomsnittlig, noe som tyder på at du er noe opptatt av andres behov, men generelt lite villig til å ofre deg for andre.'
    },
    {
      score: 'high',
      text: 'Ditt høye resultat på medmenneskelighet tyder på en utpreget interesse for andres behov og deres ve og vel. Du er hyggelig, sympatisk og samarbeidsvillig.'
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'Tillit',
      text: 'En person som skårer høyt på tillit ser som oftest på andre mennesker som rettferdige, ærlige og at de har gode hensikter. Personer som skårer lavt på tillit ser på andre som selvopptatte, bedragerske og potensielt farlige.'
    },
    {
      facet: 2,
      title: 'Moral',
      text: `De som skårer høyt på denne fasetten ser ikke noe behov for å forstille seg eller manipulere i relasjoner med andre og er derfor ærlige, åpne og oppriktige.
De som skårer lavt mener at det kan være nødvendig å bløffe og skjule ting i sosiale relasjoner.
Folk synes det er relativt lett å forholde seg til de likeframme individene som skårer høyt her.
De finner det generelt vanskeligere å forholde seg til de som skårer lavt.

Det skal understrekes at de som skårer lavt er ikke prinsippløse eller umoralske;

de er bare mer vaktsomme og mindre tilbøyelige til å avdekke hele sannheten.`
    },
    {
      facet: 3,
      title: 'Altruisme',
      text: `Altruistiske mennesker ser det å hjelpe andre mennesker som belønning i seg selv.

Derfor er de generelt villige til hjelpe de som er i nød. Altruistiske mennesker synes at det å gjøre

ting for andre er en form for selvrealisering snarere enn et offer.

De som skårer lavt på denne fasetten er ikke spesielt opptatt av å hjelpe de som er i nød.

Når man blir bedt om hjelp føles det som en byrde, ikke som en mulighet til selv-realisering.`
    },
    {
      facet: 4,
      title: 'Føyelighet',
      text: `Individer som skårer høyt på denne fasetten misliker konfrontasjoner.

De er svært tilbøyelige til å finne kompromisser eller de vil undertrykke egne behov for å komme overens med andre.

De som skårer lavt på denne fasetten er mer tilbøyelige til å støte andre for å oppnå egne mål.`
    },
    {
      facet: 5,
      title: 'Beskjedenhet',
      text: `De som skårer høyt på denne fasetten liker ikke å hevde at de er bedre enn andre mennesker.

I noen tilfeller kan denne holdningen skyldes lav selvfølelse eller selvtillit.

Allikevel, noen mennesker med høy selvtillit finner ubeskjedenhet upassende.

De som er er villig til å beskrive seg selv som overlegne andre mennesker blir ofte sett på som ubehagelig arrogante av andre.`
    },
    {
      facet: 6,
      title: 'Følsomhet',
      text: `Individer som skårer høyt på denne fasetten er medfølende og følsomme.

De føler smerten til andre og blir lett rørt til medfølelse.

De som skårer lavt blir ikke så berørt av menneskelig lidelse.

De er stolt av at de klarer å gjøre objektive vurderinger basert på fornuft.

De er mer opptatt av sannhet og upartisk rettferdighet enn barmhjertighet.`
    }
  ]
}
